import { ModuleWidget, SOFTLINE_WIDGET_OUTLET_DASHBOARD } from '@softapps/core';
import {
  SOFTLINE_PERMISSIONS_OFFENE_POSTEN_DEBITOR_WIDGET,
  SOFTLINE_PERMISSIONS_OFFENE_POSTEN_KREDITOR_WIDGET,
  SOFTLINE_PERMISSIONS_OFFENE_POSTEN_WIDGET,
} from './offene-posten.shared';

// Widget registrations — loaded when a matching widget-outlet renders
// (federation) or re-provided via provideModuleWidgets by the legacy composition.
export function offenePostenWidgets(): ModuleWidget[] {
  return [
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'fibu',
      loadComponent: () =>
        import('./widgets/offene-posten/offene-posten.widget').then(
          (m) => m.OffenePostenWidgetComponent
        ),
      permission: SOFTLINE_PERMISSIONS_OFFENE_POSTEN_WIDGET,
    },
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'fibu',
      loadComponent: () =>
        import('./widgets/offene-posten-debitoren/offene-posten-debitoren.widget').then(
          (m) => m.OffenePostenDebitorenWidgetComponent
        ),
      permission: SOFTLINE_PERMISSIONS_OFFENE_POSTEN_DEBITOR_WIDGET,
    },
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'fibu',
      loadComponent: () =>
        import('./widgets/offene-posten-kreditoren/offene-posten-kreditoren.widget').then(
          (m) => m.OffenePostenKreditorenWidgetComponent
        ),
      permission: SOFTLINE_PERMISSIONS_OFFENE_POSTEN_KREDITOR_WIDGET,
    },
  ];
}
